import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { Helmet } from './helmet.component';
import { selectAssets, selectWebsiteConfig } from '../../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  assets: selectAssets,
  websiteConfig: selectWebsiteConfig,
});

export default compose(
  hot(module),
  connect(mapStateToProps)
)(Helmet);
